/**
 * Coerce a FileReader result to plain text for the source upload box.
 *
 * `FileReader.readAsText` yields a string, but the typed `result` is
 * `string | ArrayBuffer | null`; this normalizes the non-string cases (a binary
 * read or an error) to an empty string so the upload box never shows binary.
 */

/**
 * Normalize a FileReader result to a text string.
 *
 * @param result - The reader's `result` (`string | ArrayBuffer | null`).
 * @returns The text when the read produced a string, otherwise an empty string.
 */
export function fileResultToText(result: string | ArrayBuffer | null): string {
  return typeof result === "string" ? result : "";
}
